import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scrollable-table-container" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollableTable',
  setup(__props) {

/* ... */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})